import React, { useState } from 'react'

import { Slider } from '../../routes/Home/Old/types'
import { withSwipe } from '../WithSwipe'
import { Navigation } from './components/Navigation'
import { Arrows } from './components/Navigation/Arrows'
import { Slides } from './components/Slides'
import Wrapper from './styles/Wrapper'

interface Props {
  slider: Slider
  duration: number
  arrowClickHandler: (direction: string) => void
  goToSlide: (index: number) => void
  onTransitionEnd: () => void
  clear: () => void
  start: () => void
}

const WrapperWithSwipe = withSwipe(Wrapper)

export default function HomeBanner({
  slider,
  arrowClickHandler,
  goToSlide,
  onTransitionEnd,
  duration,
  clear,
  start,
}: Props) {
  const [paused, setPaused] = useState(false)

  return (
    <WrapperWithSwipe
      id="home-banner"
      onLeftSwipe={() => arrowClickHandler('next')}
      onRightSwipe={() => arrowClickHandler('prev')}
      onMouseOver={() => {
        clear()
        setPaused(true)
      }}
      onMouseLeave={() => {
        start()
        setPaused(false)
      }}
    >
      <Slides
        slider={slider}
        onTransitionEnd={onTransitionEnd}
      />
      <Arrows
        slidesAmount={slider.slides?.length || 0}
        isTransitioning={slider.transitioning}
        arrowClickHandler={arrowClickHandler}
      />
      <Navigation
        currentSlide={slider.currentSlide}
        slidesAmount={slider.slides?.length || 0}
        goToSlide={(index) => goToSlide(index)}
        isTransitioning={slider.transitioning}
        duration={duration}
        paused={paused}
      />
    </WrapperWithSwipe>
  )
}
